var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedVoltageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FFA700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4a.5.5 0 01.5.5V7h3V4.5a.5.5 0 011 0V7h1a.5.5 0 01.5.5v3a3.5 3.5 0 01-3.5 3.5c-.002.434-.01.845-.04 1.22-.041.514-.126 1.003-.317 1.424a2.083 2.083 0 01-.97 1.028C10.725 17.9 10.169 18 9.5 18c-.998 0-1.61.33-1.974.718A1.922 1.922 0 007 20H6c0-.616.232-1.367.797-1.968C7.374 17.42 8.261 17 9.5 17c.581 0 .962-.088 1.218-.219.241-.123.4-.3.514-.55.121-.266.193-.621.23-1.09.027-.34.035-.718.037-1.141A3.5 3.5 0 018 10.5v-3a.5.5 0 01.5-.5h1V4.5A.5.5 0 0110 4zM9 8v2.5a2.5 2.5 0 002.5 2.5h1a2.5 2.5 0 002.5-2.5V8H9z",
    fill: "#fff"
  })));
}
export default SvgLedVoltageIcon;